import { gql } from '@apollo/client';

export const productIntroQuery = gql`
  query GetProductIntro($sessionContext: SessionContext!, $appId: String!) {
    productIntro(sessionContext: $sessionContext, appId: $appId) {
      screens {
        title
        summary
        image {
          url
        }
        continueButtonCopy
        skipButtonCopy
      }
    }
  }
`;
